var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCheckedBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66898 7.46659L10.8457 8.64325L17.9007 1.58825L19.079 2.76659L10.8457 10.9999L5.54232 5.69659L6.72065 4.51826L8.49148 6.28909L9.66898 7.46575V7.46659ZM9.67065 5.10992L13.7973 0.982422L14.9723 2.15742L10.8457 6.28492L9.67065 5.10992ZM7.31482 9.82242L6.13732 10.9999L0.833984 5.69659L2.01232 4.51826L3.18982 5.69576L3.18898 5.69659L7.31482 9.82242Z",
    fill: "#2544B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheckedBlue);
export default __webpack_public_path__ + "static/media/double-checked-blue.3c054d35a87bedeb35cc5882d7eab8a6.svg";
export { ForwardRef as ReactComponent };